import { SITE_ID_TO_SWITCH } from 'src/js/constants/common';

const getSiteIdToSwitchTemplate = () => {
  const parsedUrl = new URL(window.location.href);

  return parsedUrl.searchParams.get(SITE_ID_TO_SWITCH);
};

export default getSiteIdToSwitchTemplate;
